module.exports = {
  "country": "ES",
  "artist": "Massiel ",
  "song": "La La La",
  "year": "1968",
  "place": "1",
  "spotify": "1ApXNkjfjxkSDoezO8Kh8g"
};